import {
  Button,
  ButtonProps,
  ElementProps,
  Group,
  Loader,
  Text,
} from '@mantine/core'

export interface UpdateButtonProps extends ButtonProps, ElementProps<'button', keyof ButtonProps> {
  buttonText: string
  loadingText?: string
}

export const UpdateButton = ({
                               buttonText,
                               loading,
                               loadingText = 'Loading...',
                               ...buttonProps
                             }: UpdateButtonProps) => {
  return (
    <Button {...buttonProps}>
      {loading ? (
        <Group gap='xs'>
          <Loader
            size='xs'
            color='white'
          />
          <Text size='sm'>
            {loadingText}
          </Text>
        </Group>
      ) : (
        buttonText
      )}
    </Button>
  )
}